import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../../api/snackbarSlice';
import { apiClient } from '../../../utils/axios';
import { riskComplianceBasePath } from './riskCompliancePaths';
import { useRiskComplianceErrorMessage } from './useRiskComplianceErrorMessage';

export const useLinkCustomerDunsHandler = (profileId) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const getErrorMessage = useRiskComplianceErrorMessage();

  return useMutation({
    mutationFn: async ({ successMessage: _successMessage, ...payload }) => {
      const { data } = await apiClient.post(`${riskComplianceBasePath(profileId)}/link-duns`, payload);
      return data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['customers', profileId, 'crif', 'risk-compliance'] });
      dispatch(
        showSnackbar({
          message: variables?.successMessage || 'DUNS linked successfully.',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: getErrorMessage(error), severity: 'error' }));
    },
  });
};
